import { AxiosInstance } from 'axios';

import { ApiResponse } from 'models/ApiResponse';

export interface DeleteFileResponse {
  file_id: string;
  is_deleted: boolean;
  deleted_date: string;
  deleted_user_id: string;
  /** Reads "...deleted successfully", or "...is already deleted" on a repeat call. */
  message: string;
}

export default class FileManagementAPI {
  client: AxiosInstance;
  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async listFileTypes() {
    return this.client.get('/v2/file-management/file-type/');
  }

  async deleteFile(fileId: string) {
    return this.client.delete<ApiResponse<DeleteFileResponse>>(
      `/v2/file-management/file/${fileId}/`,
    );
  }
}
